import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Body from '../Components/layout/Body';
import { TABS } from './ConstPaths';

const REVIEW_INTRO_HELP = `
  <div>
    <p>At this point, you’ve generally completed a couple of Test-drives (or more). 
    Maybe you’ve started to think about next steps.  
    The Review section helps you consider what you’ve done so far and talk through what comes next. 
    </p>
    <p>Perhaps you’ve found a solution or two that really seem like a good fit for the client’s needs.  
    Or perhaps you still want to try out some more possibilities.  You can document all that here.   
    </p>
    <p>A couple of terminology notes:</p> 
    <ul>
      <li><strong>Prospects</strong> are access method setups that you’ve tried and are still considering.  
        As soon as you start a Test-drive with an access method, that access method automatically becomes a Prospect.
      </li>
      <li><strong>Your Picks</strong> are access method setups that you’ve chosen out of the Prospects.  
      These are access methods that seem to have the most promise out of those you’ve tried so far.  
      They represent access methods that you are going to pursue further, either for continued trials or for actual delivery to the client. 
      </li>
    </ul>
  </div>
`;

const propTypes = {
  testDrives: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  testDrives: [],
};

//content sub-component with unique content for this page
function ReviewTabIntroContent(props) {
  const testDrives = props.testDrives;
  const td_path = TABS.TEST;

  if (testDrives.length > 0){
    return(
      <>
      <p><strong>Great job on those Test-drives!</strong> We're ready to review what you've done and help you make decisions about what comes next.</p>
      <p>Here's what we'll cover:</p>
      <ul>
        <li>Give you a chance to compare setups that you've already tried</li>
        <li>Review Your Prospects to decide what to keep and whether you've found any good solutions yet</li>
        <li>Determine and document next steps</li>
      </ul>
      </>
    );
  }
  else{
    return(
      <>
      <p>We don't have any Test-drive data, so there's really nothing to review yet.</p>
      <p>You can:</p>
      <ul>
        <li><Link to={td_path}>Start a Test-drive</Link>, complete one or more, then review the results here.</li>
      </ul>
      </>
    )
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function ReviewTabIntro(props) {
  const testDrives = props.testDrives;
  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "",
    pageSectionClassName: "main-section review",
    majorHeading: "Review and define next steps",
    title: `Let's take action based on what you've learned!`,
    subTitle: ``,
    learnMore: {linkText: "Learn More about Review and decision-making",
                title: "The Review section",
                content: REVIEW_INTRO_HELP
                },
    nextRoute: "/review/compare", //static name for next page
    sidebar: false
  }

  console.log("Rendering ReviewTabIntro");
  
  return(
    <>
    <Body page={pageData} contentComponent={<ReviewTabIntroContent testDrives={testDrives}/>} />
    </>
  );
}

ReviewTabIntro.propTypes = propTypes;
ReviewTabIntro.defaultProps = defaultProps;

export default ReviewTabIntro;